import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-success-authenticate',
  imports: [MatProgressSpinner, TranslatePipe],
  standalone: true,
  templateUrl: './authenticate-success.component.html',
  styleUrl: './authenticate-success.component.scss'
})
export class AuthenticateSuccessComponent implements OnInit {
  @Input() workosToken = '';
  @Input() workosSessionId = '';
  @Input() redirectUri = '';

  constructor(private _translate: TranslateService) { }

  ngOnInit(): void {
    window.location.href = `${this.redirectUri}?workosToken=${this.workosToken}&workosSessionId=${this.workosSessionId}&lang=${this._translate.currentLang}`;
  }
}
